import React from 'react';
import { ButtonContainer } from './CircularButtonWithIcon.styles';

export interface CircularButtonWithIconProps {
    size?: number;
    icon?: React.ReactNode;
    onClick?: (event: React.MouseEvent) => void;
    ariaLabel?: string;
}

const CircularButtonWithIcon = ({
    size = 36,
    icon,
    onClick,
    ariaLabel = 'Action',
}: CircularButtonWithIconProps) => {
    return (
        <ButtonContainer
            type="button"
            aria-label={ariaLabel}
            $size={size}
            $isClickable={!!onClick}
            onClick={onClick}
        >
            {icon || <DefaultIcon />}
        </ButtonContainer>
    )
}

export default CircularButtonWithIcon;

const DefaultIcon = () => {
    return (
        <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M2 0C0.895431 0 0 0.895431 0 2V16L3.5 14L7 16L10.5 14L14 16V2C14 0.895431 13.1046 0 12 0H2ZM6.70711 3.70711C7.09763 3.31658 7.09763 2.68342 6.70711 2.29289C6.31658 1.90237 5.68342 1.90237 5.29289 2.29289L2.29289 5.29289C1.90237 5.68342 1.90237 6.31658 2.29289 6.70711L5.29289 9.70711C5.68342 10.0976 6.31658 10.0976 6.70711 9.70711C7.09763 9.31658 7.09763 8.68342 6.70711 8.29289L5.41421 7H7C8.65685 7 10 8.34315 10 10V11C10 11.5523 10.4477 12 11 12C11.5523 12 12 11.5523 12 11V10C12 7.23858 9.76142 5 7 5H5.41421L6.70711 3.70711Z" fill="white"/>
        </svg>
    )
}
